<template>
  <div class="p-4">
    <div class="row no-gutters">
      <div class="col-md-12">
        <form v-on:submit.prevent>
          <validated-input
            label="Quantity"
            class="mr-2 mb-0"
            v-model="item.quantity"
            :validate="{ required: true, min: 0 }"
            name="Quantity"
            :help-options="{
              content: 'Product part quantity allowed to add to cart',
              html: true
            }"
          />
          <autocomplete-input
            :path="`/store-roles?storeId=${store._id}&limit=25`"
            :name="'StoreRole'"
            label="name"
            loadOnFocus
            isObject
            :track-by="'_id'"
            :defValue="item.storeRole"
            v-model="item.storeRole"
            v-validate="`required`"
            :help-options="{ content: 'Store customer role.', html: true }"
          />
          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label>Description </label>
            </div>
            <b-form-textarea
              v-model="item.description"
              class="form-control"
              rows="3"
              :name="`Description`"
              v-validate="`max:1024`"
            />
          </div>
        </form>
      </div>
    </div>

    <div class="d-flex justify-content-between border-top pt-3 bg-white p-3">
      <div class="flex-grow">
        <span class="col-md-12 text-danger" v-if="error">{{ error.message }}</span>
      </div>
      <div class="d-flex justify-content-end">
        <b-btn @click="cancel" variant="primary" class="btn btn-light mr-2"> Close </b-btn>
        <b-btn @click="submit" variant="primary" :disabled="errors.any() || pending">
          <i class="far fa-spinner-third fa-spin text-white" v-show="pending"></i>
          Save
        </b-btn>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    PartsDropdownOption: () => import('../../../../../components/PartsDropdownOption'),
    PartsFormTabPrices: () => import('../../PartsFormTabPrices')
  },
  props: {
    remove: Function,
    error: Object | Boolean,
    item: Object,
    store: Object,
    product: Object,
    pending: Boolean
  },
  data() {
    return {};
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      await this.$validator.validateAll();
      if (this.errors.any()) return console.log(this.errors.any());
      this.$emit('submit', this.item);
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>
